import React, { useEffect } from "react";
import tools from "../../../helpers/tools";
import Page from "../../common/layout/Page";
import Loader from "../../common/Loader";
import useSectors from "../../Hooks/useSectors/useSectors";
import useRecipientStock from "../RecipientStockList/useRecipientStock";
import RecipientStockActions from "./RecipientStockActions";
import RecipientStockInfo from "./RecipientStockInfo";
import RecipientOrientation from "./RecipientOrientation";
import useOrganizations from "../../Hooks/useOrganizations/useOrganizations";
import ForceSynchroFTButton from "../RecipientDetail/ForceSynchroFTButton";
import { DateTime } from "luxon";

const RecipientStockDetail = (props) => {
  const { organizations, onGetOrganizations } = useOrganizations();

  useEffect(() => {
    onGetOrganizations();
  }, []);
  const {
    currentRecipientStock,
    onGetRecipientStockById,
    isLoadingCurrentRecipientStock,
  } = useRecipientStock();
  const { sectors, getSectors } = useSectors();

  useEffect(() => {
    const { id } = props.match.params;
    onGetRecipientStockById(id);
    if (sectors.length == 0) {
      getSectors();
    }
  }, []);

  return isLoadingCurrentRecipientStock ||
    !currentRecipientStock ||
    !organizations ? (
    <Loader />
  ) : (
    <Page
      bgTransparent
      back={`/recipients-stock`}
      container="container"
      title={`Allocataire stock - ${tools.getFullname(currentRecipientStock)}`}
    >
      <RecipientStockActions />
      <RecipientOrientation
        recipient={currentRecipientStock}
        orgs={organizations}
      />

      {currentRecipientStock?.id && (
        <div className="d-flex justify-content-end mb-2">
          <ForceSynchroFTButton
            categorie="ORIENTATION"
            entiteId={currentRecipientStock.id}
            label="Resynchroniser l'orientation"
            onSuccess={() =>
              onGetRecipientStockById(props.match.params.id)
            }
          />
        </div>
      )}
      <RecipientStockInfo />
    </Page>
  );
};

export default RecipientStockDetail;
